define('plugin/facebook-pixel/PackageInflator',['require','marionette'],function (require) {

    var Marionette = require('marionette');

    /**
     * Package inflator for Facebook Pixel plugin
     *
     * @class PackageInflator
     */
    return Marionette.Object.extend({
        inflate: function (contentData, model, data) {
            var packageData = model.get('package');

            _.extend(contentData, {
                content_ids: [packageData.id],
                content_type: model.get('type'),
                contents: [{
                    id: packageData.id,
                    name: packageData.name,
                    duration: packageData.duration,
                    duration_type: packageData.duration_type,
                    price: parseFloat(packageData.price),
                    services: packageData.services,
                    products: packageData.products
                }],
                period_start: model.get('period_start')
            });
        }
    });

});

